var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Echarts',{staticClass:"echarts-view",attrs:{"data":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }